import { FC } from "react";
import { Link, Image } from "capitalrx-components-2.0";
import { GOOGLE_PLAY_STORE_APP_URL } from "@/constants/constants";

import GooglePlayLogoSvg from "@/static/images/google-play.svg?url";

interface Props {
  className?: string;
}

const AndroidStudiosLogo: FC<Props> = ({ className }: Props): JSX.Element => {
  return (
    <Link href={GOOGLE_PLAY_STORE_APP_URL} testId="google-store-logo" className={className}>
      <Image className={className} src={GooglePlayLogoSvg} alt="Google Play Store" />
    </Link>
  );
};

export default AndroidStudiosLogo;
